import api from 'api/balance';
import { useEffect, useState } from 'react';
import { BalanceType, ContractType } from '../types';

export const useLoadBalance = () => {
  const [isLoading, setLoading] = useState(false);
  const [balanceList, setBalanceList] = useState<BalanceType[]>([]);
  const [contractList, setContractList] = useState<ContractType[]>([]);

  const fetchBalanceList = async (selectedContracts?: number[]) => {
    setLoading(false);

    try {
      const balanceData = await api.getBalance(selectedContracts);
      setBalanceList(balanceData);
    } finally {
      setLoading(true);
    }
  };

  const fetchContractsList = async () => {
    try {
      const contracts = await api.getContracts();
      const mappedContractList = contracts.map((item) => ({
        id: item.id,
        text: item.title,
        isSelected: false,
      }));
      setContractList(mappedContractList);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchData = async () => {
    try {
      await Promise.all([fetchBalanceList(), fetchContractsList()]);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleFilterChange = (selectedContracts: ContractType[]) => {
    const selectedIds = selectedContracts
      .filter((item) => item.isSelected)
      .map((item) => item.id);

    setContractList(selectedContracts);
    fetchBalanceList(selectedIds);
  };
  return {
    isLoading,
    balanceList,
    contractList,
    handleFilterChange,
  };
};
